import { GameCenterDayLayout } from '@sorare/gameplay/src/layouts/game-center/GameCenterDayLayout';

import type { LayoutParams } from './__generated__/routeParams';

export const ScoutingCenterGamesDayLayout = () => {
  return <GameCenterDayLayout<LayoutParams> />;
};

export default ScoutingCenterGamesDayLayout;
